import script from "./VbRechercheDetailsComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./VbRechercheDetailsComponent.vue?vue&type=script&setup=true&lang=ts"

import "./VbRechercheDetailsComponent.vue?vue&type=style&index=0&id=8e5439ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e5439ec"]])

export default __exports__